import React from 'react'
import CustomeCircularProgressbar from './CustomeLabel/CustomeCircularProgressbar';
import { getPercentage } from './FewCommonMethods';
import RatingCircularProgressbar from './CustomeLabel/RatingCircularProgressbar';
import { decodeHtml } from '../../assests/extention/commonfunction';

export default function ChildRatingStar({ ratings }) {
    const StarRating = ({ rating }) => {
        const maxStars = 5;
        return (
            <div className="star-sec">
                {[...Array(maxStars)].map((_, i) => (
                    <i
                        key={i}
                        className={i < rating ? "fa-solid fa-star" : "fa-solid fa-star disabled"}
                    ></i>
                ))}
            </div>
        );
    };

    return (
        <div>
            {ratings &&
                ratings.map((rating, indi) => (
                    <div
                        className="rating-detail"
                        key={indi}
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            width: "100%",
                            gap: "20px",
                        }}
                    >
                        {/* Left Column – 6 */}
                        <div style={{ width: "50%" }}>
                            <p>{decodeHtml(rating.comment)}</p>
                            <h5>
                                {decodeHtml(rating.first_name)} {decodeHtml(rating.last_name)}
                                <StarRating rating={Number(Array.isArray(rating?.category) && rating?.category[0]?.rating || 0)} />
                            </h5>

                        </div>

                        {/* Right Column – 6 */}
                        <div style={{ width: "50%" }}>
                            {rating && Array.isArray(rating?.category) && rating.category?.length > 0 && (
                                <div className="overall-rating review-circular-rating">
                                    {
                                        rating?.category?.map((rat_cat_child, indi) => (
                                            <div className="review-star" key={indi}>
                                                <RatingCircularProgressbar
                                                    percentage={getPercentage(rat_cat_child.rating, 5)}
                                                    count={rat_cat_child.rating}
                                                />
                                                <p style={{ fontSize: 8 }}>{decodeHtml(rat_cat_child.title)}</p>
                                            </div>
                                        ))}
                                </div>
                            )}
                        </div>

                    </div>

                ))}
        </div>
    )
}
